import { FC, ReactNode } from 'react';

import { Modal } from '@/shared/ui';

interface Props {
  title?: string;
  message: ReactNode;
  actionButtons: ReactNode;
}

export const UnavailabilityModal: FC<Props> = ({ title, message, actionButtons }) => {
  return (
    <Modal
      open
      title={title ?? 'Помилка'}
      closable={false}
      width={750}
      className="service-unavailable-modal"
      styles={{
        content: { padding: 40 },
        footer: { marginTop: 20 },
      }}
      footer={<div className="service-unavailable-modal__footer">{actionButtons}</div>}
    >
      {message}
    </Modal>
  );
};
